// extracted by mini-css-extract-plugin
module.exports = {"main":"MenuItem_main__jGEjQ","dot":"MenuItem_dot__1YrGV","realDot":"MenuItem_realDot__m0pia","item":"MenuItem_item__UL-o9"};